<!--
  @Description 按钮组
  @Date 2021-12-23
  @Author liushuo
-->
<template>
  <div class="toolBarBtn-container">
    <!-- 固定按钮 -->
    <div
      v-for="(item, index) of defaultButtonList"
      :key="index + item.name"
      :class="
        parentData.Authority[item.authority] ? 'btn-dv' : 'btn-dv-prohibit'
      "
      v-show="
        buttonVisible[item.prop] === false ? buttonVisible[item.prop] : true
      "
      @click="
        parentData.Authority[item.authority] ? handleEvent(item.prop) : ''
      "
    >
      <button>
        <i :class="item.icon"></i>
      </button>
      <span class="tooltip">{{ item.name }}</span>
    </div>
    <!-- 新增问题 -->
    <!-- btn-dv-prohibit 禁用 -->
    <!-- <div
      :class="parentData.Authority.edit ? 'btn-dv' : 'btn-dv-prohibit'"
      v-show="buttonVisible.add === false ? buttonVisible.add : true"
      @click="parentData.Authority.edit ? handleEvent('add') : ''"
    >
      <button>
        <i class="el-icon-document-add"></i>
      </button>
      <span class="tooltip">新增</span>
    </div> -->

    <!-- 编辑按钮 -->
    <!-- <div
      :class="parentData.Authority.edit ? 'btn-dv' : 'btn-dv-prohibit'"
      v-show="buttonVisible.update === false ? buttonVisible.update : true"
      @click="parentData.Authority.edit ? handleEvent('update') : ''"
    >
      <button>
        <i class="el-icon-edit-outline"></i>
      </button>
      <span class="tooltip">编辑</span>
    </div> -->

    <!-- 保存 -->
    <!-- <div
      :class="parentData.Authority.edit ? 'btn-dv' : 'btn-dv-prohibit'"
      v-show="buttonVisible.save === false ? buttonVisible.save : true"
      @click="parentData.Authority.edit ? handleEvent('save') : ''"
    >
      <button>
        <i class="el-icon-folder-checked"></i>
      </button>
      <span class="tooltip">保存</span>
    </div> -->

    <!-- 删除 -->
    <!-- <div
      :class="parentData.Authority.edit ? 'btn-dv' : 'btn-dv-prohibit'"
      v-show="buttonVisible.delete === false ? buttonVisible.delete : true"
      @click="parentData.Authority.edit ? handleEvent('delete') : ''"
    >
      <button>
        <i class="el-icon-delete"></i>
      </button>
      <span class="tooltip">删除</span>
    </div> -->
    <!-- 刷新数据 -->
    <!-- <div
      :class="parentData.Authority.see ? 'btn-dv' : 'btn-dv-prohibit'"
      v-show="buttonVisible.refresh === false ? buttonVisible.refresh : true"
      @click="parentData.Authority.see ? handleEvent('refresh') : ''"
    >
      <button>
        <i class="el-icon-refresh"></i>
      </button>
      <span class="tooltip">刷新数据</span>
    </div> -->

    <!-- 查找 -->
    <!-- <div
      :class="parentData.Authority.see ? 'btn-dv' : 'btn-dv-prohibit'"
      v-show="buttonVisible.search === false ? buttonVisible.search : true"
    >
      <button @click="parentData.Authority.see ? handleEvent('search') : ''">
        <i class="el-icon-search"></i>
      </button>
      <span class="tooltip">查找</span>
    </div> -->

    <!-- 排序 -->
    <!-- <div
      :class="parentData.Authority.edit ? 'btn-dv' : 'btn-dv-prohibit'"
      v-show="buttonVisible.sort === false ? buttonVisible.sort : true"
      @click="parentData.Authority.edit ? handleEvent('sort') : ''"
    >
      <button>
        <i class="el-icon-sort"></i>
      </button>
      <span class="tooltip">排序</span>
    </div> -->

    <!-- 横向拓展按钮组 -->
    <div
      v-for="(item, index) in moreButtonList"
      :class="item.disabled ? 'btn-dv-prohibit' : 'btn-dv'"
      :key="index"
      v-show="item.visible === false ? item.visible : true"
      @click="item.disabled ? '' : handleEvent(item.event)"
    >
      <button>
        <i :class="item.icon ? item.icon : 'el-icon-document'"></i>
      </button>
      <span class="tooltip">{{ item.name }}</span>
    </div>

    <!-- 扩展 -->
    <!-- <div
      class="btn-dv"
      v-show="buttonVisible.more === false ? buttonVisible.more : true"
    >
      <button>
        <i class="el-icon-more"></i>
      </button>
      <span class="tooltip">扩展</span>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    // 整个父组件带过来
    parentData: {
      type: Object,
      default: () => {
        return {
          Authority: {
            see: false,
            edit: false
          }
        }
      }
    },
    // 拓展按钮格式: { icon: xxx, name: xxx, event: xxx, visible: xxx }
    moreButtonList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否显示某个按钮：需要隐藏的时候再写，不需要可以不写例如 :buttonVisible={ add: false } 其他的可以不用写
    buttonVisible: {
      type: Object,
      default: () => {
        return {
          add: true, // 新增按钮是否显示
          update: true, // 新增按钮是否显示
          save: true, // 保存按钮是否显示
          delete: true, // 删除按钮是否显示
          refresh: true, // 刷新按钮是否显示
          lock: true, // 锁定按钮是否显示
          unlock: true, // 解锁按钮是否显示
          sort: true, // 排序按钮是否显示
          search: true, // 查找按钮是否显示
          more: true // 更多按钮是否显示
        }
      }
    }
  },
  data () {
    return {
      // 固定按钮组
      defaultButtonList: [
        {
          name: '新增',
          prop: 'add',
          icon: 'el-icon-document-add',
          authority: 'edit'
        },
        {
          name: '编辑',
          prop: 'update',
          icon: 'el-icon-edit-outline',
          authority: 'edit'
        },
        {
          name: '保存',
          prop: 'save',
          icon: 'el-icon-folder-checked',
          authority: 'edit'
        },
        {
          name: '删除',
          prop: 'delete',
          icon: 'el-icon-delete',
          authority: 'edit'
        },
        {
          name: '刷新数据',
          prop: 'refresh',
          icon: 'el-icon-refresh',
          authority: 'see'
        },
        {
          name: '查找',
          prop: 'search',
          icon: 'el-icon-search',
          authority: 'see'
        },
        {
          name: '排序',
          prop: 'sort',
          icon: 'el-icon-sort',
          authority: 'edit'
        },
      ]
    }
  },
  methods: {
    // 触发父组件事件
    handleEvent (event) {
      this.parentData[event]()
    },
    // 切换查找面板可见性（暂时弃用）
    changeSearchFormShow () {
      this.$emit('changeSearchFormShow')
    },
  }
}
</script>

<style lang="less" scoped>
.toolBarBtn-container {
  width: 100%;
  height: 40px;
  border-radius: 10px;
  display: flex;
  box-shadow: #e2e2e2 2px 2px 5px;
  background-color: #f2f3f5;
  align-items: center;
}

button {
  width: 30px;
  height: 30px;
  margin: 0 10px;
  border-radius: 5px;
  font-size: 20px;
  border: none;
  transition: @normal-transition;
  color: @able-color;
  background-color: #f2f3f5;
}
button:hover {
  cursor: pointer;
  color: #ffffff;
  background-color: #e2e2e2;
  color: #6c9eff;
  transition: @normal-transition;
}

button:active {
  cursor: pointer;
  color: #ffffff;
  background-color: #c2c2c2;
  color: #528cff;
  transition: @normal-transition;
}

.btn-dv {
  position: relative;
}
.btn-dv-prohibit {
  button {
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    border-color: #ebeef5;
  }
}
.btn-dv-prohibit:hover {
  button {
    cursor: not-allowed;
    color: #c0c4cc;
    background-image: none;
    border-color: #ebeef5;
    background-color: #f2f3f5;
  }
}
.tooltip {
  position: absolute;
  white-space: nowrap;
  // min-width: 50px;
  padding: 0 10px;
  height: 30px;
  border-radius: 5px;
  box-shadow: #e2e2e2 1px 1px 5px;
  font-size: 12px;
  background-color: #ffffff;
  color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  transition: @normal-transition;
  opacity: 0;
  top: 45px;
  transform: translateY(-50%);
  pointer-events: none;
}

.btn-dv:hover .tooltip {
  top: 55px;
  transition: all 0.2s ease;
  opacity: 1;
}
</style>
